var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isProgress)?_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"ai-progress"},_vm._l((50),function(item,index){return _c('div',{key:index,staticClass:"loading-items",style:({
        opacity:
          index * 2 < _vm.sum ? 0.2 + [(index + 1) / (_vm.sum * 50)] * _vm.sum : '0.2',
      })})}),0),_c('div',{staticClass:"loading-txt"},[_vm._v(" 加载中 ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }